import Sidebar from 'components/global/sidebar'
import Navbar from 'components/user/navbar'
import React from 'react'

const Settings = () => {
    return (
        <div className="w-full pb-20 md:px-0 px-4 pt-24  ">
            <Navbar />
            <div>
                <Sidebar />
            </div>
            <div className="w-full pl md:pr-20 ">
                <div className='light-shadow sm:p-6 py-4 px-3 rounded-md'>
                    <h3 className='text-xl font-semibold text-dark'>Edit Account Details</h3>
                    <div className='mt-6'>
                        <form className='flex flex-col gap-6'>
                            <div className='flex items-center gap-6 sm:flex-row flex-col'>
                                <input 
                                type="text"
                                className='input'
                                placeholder='Alex'
                                />
                                <input 
                                type="text"
                                className='input'
                                placeholder='Jeson'
                                />
                            </div>
                            <div className='flex items-center gap-6 sm:flex-row flex-col'>
                                <input 
                                type="text"
                                className='input'
                                placeholder='Alexjeson@gmail.com'
                                />
                                <input 
                                type="text"
                                className='input'
                                placeholder='DesignTech Company'
                                />
                            </div>
                            <div className='flex items-center gap-6 sm:flex-row flex-col'>
                                <input 
                                type="text"
                                className='input'
                                placeholder='+9122334498979'
                                />
                                <input 
                                type="text"
                                className='input'
                                placeholder='Dhaka (CIty)'
                                />
                            </div>
                            <div className='flex items-center gap-6 sm:flex-row flex-col'>
                                <input 
                                type="text"
                                className='input'
                                placeholder='India (Country)'
                                />
                                <input 
                                type="text"
                                className='input'
                                placeholder='Balglore (State)'
                                />
                            </div>
                            <div className='flex items-center gap-6 sm:flex-row flex-col'>
                                <input 
                                type="text"
                                className='input'
                                placeholder='******'
                                />
                            </div>
                            <div className='py-4'>
                                <button className="btn-primary w-[150px] py-1.5">Update</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>    
        </div>    
    )
}

export default Settings